import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import { ReactComponent as CheckmarkIcon } from 'assets/checkmark.svg'

type Props = {
  children: React.ReactNode
  isActive: boolean
  onClick: () => void
  'data-cy-handle': string
  'data-cy-state'?: string
  className?: string
}

export default function SortingOption(props: Props) {
  return (
    <Wrapper
      $isActive={props.isActive}
      className={props.className}
      onClick={() => props.onClick()}
      data-cy-handle={props['data-cy-handle']}
      data-cy-state={props['data-cy-state']}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          props.onClick()
        }
      }}
    >
      {props.children}
      {props.isActive && <CheckmarkIcon data-cy-state="has-checkmark" />}
    </Wrapper>
  )
}

const Wrapper = styled.button<{ $isActive: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing('s')};
  width: 100%;
  ${theme.ty('rc-s', null, 'rc-base')}
  color: ${theme.colors.shade.b2};

  ${({ $isActive }) =>
    $isActive &&
    `
        background: ${theme.colors.shade.vanillacreme};
        ${theme.ty('rc-s', '700', 'rc-base')}; 
        color: ${theme.colors.b0};
    `}

  &:hover {
    background: ${theme.colors.shade.vanillacreme};
    cursor: pointer;
  }
  > svg {
    align-self: end;
    height: 24px;
    width: 24px;
    > path {
      fill: ${theme.colors.b0};
    }
  }
`
